import { BENEFIT_BASE_IDS_FOR_MOVE } from '@/modules/benefit/entities/constants/benefit';
import { CONTRACT_STATUS } from '@/modules/contract/entities/enums/contract';
import { Negotiation } from '@/modules/negotiation/entities/interfaces/negotiation';
import { useCallback } from 'react';

const useFilterNegotiationMove = () => {
  const filterNegotiationActiveMove = useCallback((negotiations: Negotiation[]) => {
    return negotiations.filter(
      (negotiation) =>
        BENEFIT_BASE_IDS_FOR_MOVE.includes(negotiation.product.benefit.baseId) &&
        negotiation.contract.status === CONTRACT_STATUS.ACTIVE,
    );
  }, []);

  return {
    filterNegotiationActiveMove,
  };
};

export default useFilterNegotiationMove;
